import { CtaLink } from "@/components/common/Cta";

export default function NotFound() {
  return (
    <main className="cad-grid flex min-h-[80vh] items-center pt-24" data-testid="not-found-page">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="label-mono text-brand">Error 404 · Drawing not found</p>
        <h1 className="mt-6 font-display text-6xl font-extrabold uppercase leading-none sm:text-7xl">This page isn't on the plans</h1>
        <div className="mt-10"><CtaLink to="/" testid="not-found-home-btn">Back to home</CtaLink></div>
      </div>
    </main>
  );
}
